import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import ReactMarkdown from "react-markdown";
import { createEditorialPlan } from "../editorial-analysis";
import { PostTitle } from "../PostTitle";

export function GroundingPost({ post, onEdit }) {
  const plan = createEditorialPlan(post);

  return (
    <Box component="article" className="post post--grounding" sx={{ py: { xs: 2, sm: 3 } }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
        {plan.isPrivate ? <Chip size="small" label="Privat" /> : null}
        {plan.visibility === "users" ? (
          <Chip size="small" label="Brugere" color="info" variant="outlined" />
        ) : null}
        {plan.dateLabel ? (
          <Typography variant="body2" color="text.secondary">
            {plan.dateLabel}
          </Typography>
        ) : null}
      </Box>
      <PostTitle title={plan.title} onEdit={onEdit} />
      {plan.author?.name ? (
        <Typography
          component={RouterLink}
          to={`/?author=${encodeURIComponent(plan.author.name)}`}
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1, display: "inline-block", textDecoration: "none", "&:hover": { color: "primary.main" } }}
        >
          {plan.author.name}
        </Typography>
      ) : null}
      {plan.tags?.length ? (
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
          {plan.tags.map((t) => (
            <Chip key={t} size="small" label={t} variant="outlined" />
          ))}
        </Stack>
      ) : null}

      <Box
        className="post-content post-content--grounding"
        sx={{
          "& h2": {
            fontSize: "1rem",
            fontWeight: 600,
            color: "text.secondary",
            mt: 3,
            mb: 1,
            letterSpacing: "-0.01em",
            "&:first-of-type": { mt: 0 },
          },
          "& p": {
            fontSize: "1.05rem",
            lineHeight: 1.7,
            mb: 1.5,
          },
        }}
      >
        <ReactMarkdown>{post.body || ""}</ReactMarkdown>
      </Box>
    </Box>
  );
}

export default GroundingPost;
